import React, { useState, useEffect, useMemo } from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import cn from "classnames";
import { destroyAllState, Storage } from "@/helper/helper";
import { useSolutionsSelect } from "@/states/solution.state";
import style from "./TypesPreview.module.scss";
import { useHomePageTypesButton, useRegisterRequired } from "@/states/ui.state";
import { IHomePageTypeButton } from "@/types/stateTypes";
import { HiCheckCircle, HiOutlineChevronDown } from "react-icons/hi";
import { useConfig } from "@/states/common.state";
import { typesRequiredRegister } from "../PreviewResult/data/preview-result.repository";
import { useDownloadClickedState } from "@/states/user.state";
import IFThen from "@/components/common/IFThen";
import { When } from "@/components/common/When";
import { useMediaQuery } from "react-responsive";
import { mobileLandingPageTypes } from "@/constant";
import { useQrShowState } from "@/states/qr.state";
import { QR_TYPES } from "@/constant/qr_type.enum";
type TypesSelectboxProps = {
  site?: 'default' | 'qrfast' | 'qrcodecreators';
};
export const TypesSelectbox: React.FC<TypesSelectboxProps> = ({
  site = 'default'
}) => {
  const {
    solutionsSelectedTypes,
    setSolutionsType
  } = useSolutionsSelect();
  const {
    filteredHomePageTypesButton
  } = useHomePageTypesButton();
  const {
    setPayload,
    setFiles
  } = useConfig();
  const {
    setDashboardQr
  } = useQrShowState();
  const {
    setIsTypeRequireRegister
  } = useRegisterRequired();
  const {
    setDownloadClicked
  } = useDownloadClickedState();
  const removeQr = useQrShowState(state => state.removeDashboardQr);
  const isMobile = useMediaQuery({
    maxWidth: 1025
  });
  const [currentItem, setCurrentItem] = useState<IHomePageTypeButton>(filteredHomePageTypesButton[0]);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    setCurrentItem(filteredHomePageTypesButton.find(item => item.type === (solutionsSelectedTypes || QR_TYPES.URL))!);
  }, [solutionsSelectedTypes]);
  const handleClick = (param: IHomePageTypeButton) => {
    setIsOpen(!isOpen);
    setCurrentItem(param);
    setDownloadClicked(false);
    setSolutionsType({
      solutionSelectedType: param!.type
    });
    setIsTypeRequireRegister(typesRequiredRegister.includes(param.type));
    destroyAllState("on", true, true);
    setPayload(null);
    setFiles({});
    setDashboardQr({
      hasFileError: false
    });
    removeQr();
  };
  const data = useMemo(() => isMobile ? mobileLandingPageTypes : filteredHomePageTypesButton, [isMobile]);
  return <div className={style.selectType_container} data-sentry-component="TypesSelectbox" data-sentry-source-file="TypesSelectbox.tsx">
      <div className={style.selected_item} onClick={() => setIsOpen(!isOpen)}>
        <div>
          <IFThen condition={!!currentItem} Then={<div className={style.typeIcon}>
                <div className={cn(style.typeIconImage, {
            [style.typeIconImageQrfast]: site === 'qrfast'
          })}>
                  <Image width={20} height={20} src={`/types/${currentItem?.type}.svg`} alt="Type icon" />
                </div>
                <span>{currentItem?.landingPageTitle}</span>
              </div>} Else={<span>Select Qr type</span>} data-sentry-element="IFThen" data-sentry-source-file="TypesSelectbox.tsx" />
        </div>
        <motion.span animate={{
        rotate: !isOpen ? 0 : 180
      }} data-sentry-element="unknown" data-sentry-source-file="TypesSelectbox.tsx">
          <HiOutlineChevronDown size={24} color="#A1A1A1" data-sentry-element="HiOutlineChevronDown" data-sentry-source-file="TypesSelectbox.tsx" />
        </motion.span>
      </div>
      <ul style={{
      display: isOpen ? "block" : "none"
    }}>
        {data.map((item: IHomePageTypeButton) => {
        return <li style={{
          padding: 0
        }} key={item.type} onClick={() => handleClick(item)} className={cn({
          [style.activeButton]: currentItem?.type === item.type
        })}>
              <span>
                {item.landingPageTitle}
                <When condition={currentItem?.type === item.type}>
                  <HiCheckCircle size={20} color={site === 'qrfast' ? "#aa00fd" : "#399930"} />
                </When>
              </span>
            </li>;
      })}
      </ul>
    </div>;
};